import React, { useContext } from "react";
import styles from "./ToggleThemeButton.module.scss";

import { FaSun, FaMoon } from "react-icons/fa";

import { ThemeContext } from "../../../context/ThemeContext";

const DarkModeToggle = () => {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const isDark = theme === "dark";
  
    return (
    
        <label className={styles.toggleWrapper}>
          <input
            type="checkbox"
            checked={isDark}
            onChange={toggleTheme}
            className={styles.input}
          />
          <span className={styles.slider}>
            <span className={styles.icon}>
              {isDark ? <FaMoon /> : <FaSun />}
            </span>
          </span>
        </label>
 
      
    );
  };
  

export default DarkModeToggle;
